var map = {
	"./bounty_hunter_hunter.png": 4960,
	"./bounty_hunter_rogue.png": 7000,
	"./clue_scrolls_all.png": 6332,
	"./clue_scrolls_beginner.png": 1132,
	"./clue_scrolls_easy.png": 796,
	"./clue_scrolls_elite.png": 8984,
	"./clue_scrolls_hard.png": 5496,
	"./clue_scrolls_master.png": 4012,
	"./clue_scrolls_medium.png": 1240,
	"./guardians_of_the_rift.png": 1608,
	"./last_man_standing.png": 4184,
	"./league_points.png": 8516,
	"./pvp_arena.png": 4444,
	"./soul_wars_zeal.png": 3628
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3544;